import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Button, Modal } from '@ibk/shared-ui';
import { useGetEmissorProductTermsQuery } from '../../../services/emissorBenefitsApi';
import styles from './MigrationTermsModal.module.css';
export function MigrationTermsModal({ onClose }) {
    const { t } = useTranslation();
    const { currentData, isFetching, isError, refetch } = useGetEmissorProductTermsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });
    const version = currentData?.terms?.termVersion;
    const html = version?.id && version.sourceType === 'HTML' ? version.sourceValue?.trim() : undefined;
    const retry = () => {
        Promise.resolve(refetch()).catch(() => undefined);
    };
    let content;
    if (isFetching) {
        content = _jsx("output", { children: t('benefits.migration.terms.loading') });
    }
    else if (isError || !html) {
        content = (_jsxs("div", { className: styles.feedback, children: [_jsx("p", { role: 'alert', children: t('benefits.migration.terms.error') }), _jsx(Button, { variant: 'secondary', size: 'small', dataTestId: 'migration-terms-retry', onClick: retry, children: t('benefits.migration.retry') })] }));
    }
    else {
        content = (_jsx("iframe", { className: styles.document, title: t('benefits.migration.terms.title'), srcDoc: html, sandbox: '', referrerPolicy: 'no-referrer', "data-testid": 'migration-terms-document' }));
    }
    return (_jsx(Modal, { isOpen: true, onClose: onClose, title: t('benefits.migration.terms.title'), closeButtonAriaLabel: t('parameters.icon.close'), className: styles.modal, bodyClassName: styles.body, renderInPortal: true, "data-testid": 'migration-terms-modal', children: content }));
}
